import React, { useContext, useState, useEffect, useRef, Fragment } from 'react'
import moment from 'moment'
import {
  DeleteOutlined,
  EditOutlined,
  SearchOutlined,
  EyeOutlined,
} from '@ant-design/icons'
import {
  Table,
  Input,
  Button,
  Popconfirm,
  Form,
  message,
  Spin,
  Space,
} from 'antd'
import { Link } from 'react-router-dom'
import Highlighter from 'react-highlight-words'
import './DKInventoryReportTableEdit.scss'
import { HTTPService } from '../../otherServices/apiService'
import {
  DATE_FORMAT,
  REPORT_SORTING,
  PERMISSIONS_BY_NAME,
} from '../../otherServices/constant'
import DKInventoryForm from './DKInventoryForm'
import {
  exportCSVFile,
  downloadExcel,
  isPermission,
} from '../../otherServices/commonFunction'
import { ExportToCsv } from 'export-to-csv'


let { Search } = Input
let selectedReports = []

const EditableContext = React.createContext()
const EditableRow = ({ index, ...props }) => {
  const [form] = Form.useForm()
  return (
    <Form form={form} component={false}>
      <EditableContext.Provider value={form}>
        <tr {...props} />
      </EditableContext.Provider>
    </Form>
  )
}

const EditableCell = ({
  title,
  editable,
  children,
  dataIndex,
  record,
  handleSave,
  ...restProps
}) => {
  const [editing, setEditing] = useState(false)
  const inputRef = useRef()
  const form = useContext(EditableContext)
  useEffect(() => {
    if (editing) {
      inputRef.current.focus()
    }
  }, [editing])

  const toggleEdit = () => {
    setEditing(!editing)
    form.setFieldsValue({
      [dataIndex]: record[dataIndex],
    })
  }

  const save = async (e) => {
    try {
      const values = await form.validateFields()
      toggleEdit()
      handleSave({ ...record, ...values })
    } catch (errInfo) {
      
    }
  }

  let childNode = children

  if (editable) {
    childNode = editing ? (
      <Form.Item
        style={{
          margin: 0,
        }}
        name={dataIndex}
        rules={[
          {
            required: true,
            message: `${title} is required.`,
          },
        ]}
      >
        <Input ref={inputRef} onPressEnter={save} onBlur={save} />
      </Form.Item>
    ) : (
      <div
        className="editable-cell-value-wrap"
        style={{
          paddingRight: 20,
        }}
        onClick={toggleEdit}
      >
        {children}
      </div>
    )
  }

  return <td {...restProps}>{childNode}</td>
}

class EditableTable extends React.Component {
  state = {
    searchText: '',
    searchedColumn: '',
  }

   //search function for table columns
   getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, clearFilters }) => (
      <div className="search_filterDropdown">
        <Input
          className="search_input"
          ref={(node) => {
            this.searchInput = node
          }}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() => {
            clearFilters()
            this.onSearch(`${dataIndex}=${selectedKeys[0].trim()}`)
          }}
        />
        <Space className="btns">
          <Button
            type="primary"
            onClick={() => {
              clearFilters()
              this.onSearch(`${dataIndex}=${selectedKeys[0].trim()}`)
            }}
            icon={<SearchOutlined />}
            size="medium"
          >
            Search
          </Button>
          <Button
            onClick={() => {
              this.onFilterResetReport(`${dataIndex}`)
            }}
            size="medium"
          >
            Reset
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined style={{ color: filtered ? '#3653AA' : undefined }} />
    ),
    onFilter: (value, record) =>
      record[dataIndex]
        ? record[dataIndex]
            .toString()
            .toLowerCase()
            .includes(value.toLowerCase())
        : '',
    onFilterDropdownVisibleChange: (visible) => {
      if (visible) {
        setTimeout(() => this.searchInput.select())
      }
    },
    render: (text) =>
      this.state.searchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{ backgroundColor: '#fafafa', padding: 0 }}
          searchWords={[this.state.searchText]}
          autoEscape
          textToHighlight={text ? text.toString() : ''}
        />
      ) : (
        text
      ),
  })
 //search function
  handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm()
    this.setState({
      searchText: selectedKeys[0],
      searchedColumn: dataIndex,
    })
  }
 //function to reset filter
  handleResetReport = (clearFilters) => {
    clearFilters()
    this.setState({ searchText: '', filterValueArray: [] })
  }

  //table column properties
  constructor(props) {
    super(props)

    this.state = {
      count: 2,
      tableData: [],
      count: 0,
      currentPage: 1,
      isFormOpen: false,
      currentReport: null,
      loader: false,
      searchText: '',
      filterApplied: null,
      isAddPart: false,
      filterValueArray: [],
      selectedReportIds: [],
      isFilter: false,
      pageLimit: 20,
      filterString: '',
      selectedReport: [],
      isFilterText: false,
      selectAllExportData: [],
      selectedallReport: [],
      highlightFilterArray: [],
      loadingExportData: false,
    }
    this.getReport = this.getReport.bind(this)
  }

  componentDidMount() {
    
    if (this.state.isFilter) {
      this.getFilteredReport(this.state.filterString)
    } else {
      this.getReport('')
    }
  }

  //function to fetch table data
  async getReport(searchValue = '', currentPage = 1) {
    let offset = (currentPage - 1) * this.state.pageLimit
    let urlLink = `dk-inv-report/?${REPORT_SORTING}&limit=${
      this.state.pageLimit
    }&offset=${offset}${searchValue && { searchValue }}`
    this.setState({ loader: true, highlightFilterArray: [] })
    try {
      let res = await HTTPService({
        method: 'GET',
        url: urlLink,
      })
      if (res.success) {
        let reports = []
        for (let report of res.data.results) {
          reports.push({ ...report, key: report.id })
        }
        this.setState({
          tableData: reports,
          count: res.data.count,
          loader: false,
          searchText: searchValue || null,
          currentPage,
          isFilter: false,
          filterApplied: searchValue,
          filterValueArray: [],
          selectedReport: [],
        })
        message.success('Fetched Successfully')
      } else {
        message.error(res.message)
        this.setState({
          tableData: [],
          count: 0,
          loader: false,
          searchText: searchValue || null,
          currentPage,
         
        })
        message.error(res.message)
      }
    } catch (error) {
      message.error('Failed to Fetch')
      this.setState({
        tableData: [],
        count: 0,
        loader: false,
        searchText: searchValue || null,
        currentPage,
      })
      
    }
  }
  
   //function to fetch filtered table data
  async getFilteredReport(searchValue = '', currentPage = 1) {
    let urlLink = `dk-inv-report/?${REPORT_SORTING}&${searchValue}`
    this.setState({ loader: true })
    try {
      let userRes = await HTTPService({
        method: 'GET',
        url: urlLink,
      })
      if (userRes.success) {
        let reports = []
        for (let o of userRes.data.results) {
          reports.push({ ...o, key: o.id })
        }
        this.setState({
          tableData: reports,
          count: userRes.data.count,
          loader: false,
          searchText: searchValue || null,
          currentPage,
          filterApplied: searchValue,
        })
        message.success('Filter Applied')
      } else {
        this.setState({ loader: false })
        message.error(userRes.message)
      }
    } catch (error) {
      this.setState({ loader: false })
      message.error('Filter Not Applied')
    }
  }

  //search function
  onSearch = (value = '') => {
    let arrayOfFilter = this.state.filterValueArray
    arrayOfFilter.filter((i, index) => {
      let stringSplit = value.split('=')
      if (i.includes(stringSplit[0])) {
        arrayOfFilter.splice(index, 1)
        return i
      }
    })
    arrayOfFilter.push(value)
    let highlightArray = []
    let isFilterColor = arrayOfFilter.map((i) => {
      highlightArray.push(i.split('=')[0])
    })
    this.setState({
      filterValueArray: arrayOfFilter,
      isFilter: true,
      filterString: `${arrayOfFilter.join('&&')}`,
      highlightFilterArray: highlightArray,
    })
    this.getFilteredReport(`${arrayOfFilter.join('&&')}`)
  }

  //function to reset the applied filter
  onFilterResetReport = (value = '') => {
    let arrayOfFilter = this.state.filterValueArray
    arrayOfFilter.filter((i, index) => {
      if (i.includes(value)) {
        arrayOfFilter.splice(index, 1)
        return i
      }
    })
    let highlightArray = []
    let isFilterColor = arrayOfFilter.map((i) => {
      highlightArray.push(i.split('=')[0])
    })
    this.setState({
      filterValueArray: arrayOfFilter,
      isFilter: true,
      highlightFilterArray: highlightArray,
    })
    if (arrayOfFilter.length == 0) {
      this.getReport('')
    } else {
      this.setState({ filterString: `${arrayOfFilter.join('&&')}` })
      this.getFilteredReport(`${arrayOfFilter.join('&&')}`)
    }
  }

  handleDelete = async (key) => {
    try {
      await HTTPService({
        url: `dk-inv-report/${key}/`,
        method: 'DELETE',
      })
      message.success('Record Deleted')
      this.getReport('', this.state.currentPage)
    } catch (ex) {
      if (ex.response.status === 500) message.error('Internal Server Error')
    }
  }

  handleSave = (row) => {
    const newData = [...this.state.dataSource]
    const index = newData.findIndex((item) => row.key === item.key)
    const item = newData[index]
    newData.splice(index, 1, { ...item, ...row })
    this.setState({
      dataSource: newData,
    })
  }

  
  //function to toggle flag to open Add/Edit form
  setReportStatus = (report, mode) => {
    if (mode == 'edit') {
      this.setState({ isAddPart: false })
    } else {
      this.setState({ isAddPart: true })
    }
    this.setState({
      isFormOpen: !this.state.isFormOpen,
      currentReport: report ? report : null,
    })
    }

  handleSave = (row) => {
    const newData = [...this.state.dataSource]
    const index = newData.findIndex((item) => row.id === item.id)
    const item = newData[index]
    newData.splice(index, 1, { ...item, ...row })
    this.setState({
      dataSource: newData,
    })
  }

  //function to fetch data fot table on page change
  onChangePageNumber = async (pageNumber, PAGE_LIMIT) => {
    this.setState({ 
      loader: true, 
      pageLimit: PAGE_LIMIT, 
      selectedReport: [], 
    })
    let offset = (pageNumber - 1) * PAGE_LIMIT
    try {
      let reportRes
      if (this.state.isFilter) {
        
        reportRes = await HTTPService({
          method: 'GET',
          url: `dk-inv-report/?${this.state.searchText}&${REPORT_SORTING}&limit=${PAGE_LIMIT}&offset=${offset}`,
        })
      } else {
        reportRes = await HTTPService({
          method: 'GET',
          url: `dk-inv-report/?${REPORT_SORTING}&limit=${PAGE_LIMIT}&offset=${offset}`,
        })
      }
      if (reportRes.success) {
        let reports = [],
          count = 0
        for (let report of reportRes.data.results) {
          reports.push({ ...report, key: report.id })
        }

        count = reportRes.data.count
        this.setState({
          tableData: reports,
          count,
          currentPage: pageNumber,
          currentReport: null,
          isFormOpen: false,
          loader: false,
        })
      } else {
        message.error(reportRes.message)
        this.setState({
          isFormOpen: false,
          loader: false,
        })
      }
    } catch {
      message.error('Failed to fetch')
      this.setState({
        isFormOpen: false,
        loader: false,
      })
    }
  }

  //function to display total item
  showTotal = () => {
    return `Total ${this.state.count}`
  }

  exportData = () => {
    if (this.state.isFilter) {
      this.getExportDataFiltered()
    } else {
      this.getExportData()
    }
  }

  //function to export all data
  async getExportDataFiltered() {
    let urlLink = `export/dk-reports-csv/?${this.state.searchText}`
    let responseURL
    try {
      let userRes = await HTTPService({
        method: 'GET',
        url: urlLink,
      })
      if (userRes.success) {
        responseURL = userRes.data.url
        this.setState({ exportURL: responseURL })
        window.location.href = responseURL
      } else {
        this.setState({ loader: false })
        message.error(userRes.message)
      }
    } catch (error) {
      this.setState({ loader: false })
      
    }
  }

  async getExportData() {
    let urlLink = `export/dk-reports-csv/`
    let responseURL
    try {
      let userRes = await HTTPService({
        method: 'GET',
        url: urlLink,
      })
      if (userRes.success) {
        responseURL = userRes.data.url
        this.setState({ exportURL: responseURL })
        window.location.href = responseURL
      } else {
        this.setState({ loader: false })
        message.error(userRes.message)
      }
    } catch (error) {
      this.setState({ loader: false })
      
    }
  }

  render() {
    this.columns = [
      
       
      {
        title: 'Part Number',
        dataIndex: 'part_number',
        width: 200,
        ...this.getColumnSearchProps('part_number'),
               className: this.state.highlightFilterArray.includes('part_number')
          ? 'filtered_text'
          : '',
      },
      {
        title: 'Company of origin',
        dataIndex: 'company_of_origin',
        width: 200,
        ...this.getColumnSearchProps('company_of_origin'),
             className: this.state.highlightFilterArray.includes('company_of_origin')
          ? 'filtered_text'
          : '',
      },
     
      
      {
        title: 'Can Sample',
        dataIndex: 'can_sample',
        width: 200,
        ...this.getColumnSearchProps('can_sample'),
                className: this.state.highlightFilterArray.includes('can_sample')
          ? 'filtered_text'
          : '',
      },
      {
        title: 'Core Qty',
        dataIndex: 'core_qty',
        width: 200,
        ...this.getColumnSearchProps('core_qty'),
        className: this.state.highlightFilterArray.includes('core_qty')
          ? 'filtered_text'
          : '',
      },
      {
        title: 'Consign Qty',
        dataIndex: 'consign_qty',
        width: 200,
        ...this.getColumnSearchProps('consign_qty'),
        className: this.state.highlightFilterArray.includes('consign_qty')
          ? 'filtered_text'
          : '',
      },
      {
        title: 'Product Family',
        dataIndex: 'prod_family',
        width: 200,
        ...this.getColumnSearchProps('prod_family'),
        className: this.state.highlightFilterArray.includes('prod_family')
          ? 'filtered_text'
          : '',
      },
      {
        title: 'Market Family',
        dataIndex: 'market_family',
        width: 200,
        ...this.getColumnSearchProps('market_family'),
        className: this.state.highlightFilterArray.includes('market_family')
          ? 'filtered_text'
          : '',
      },

      {
        title: 'Load Date',
        dataIndex: 'load_date',
        width: 280,
        ...this.getColumnSearchProps('load_date'),
        className: this.state.highlightFilterArray.includes('load_date')
          ? 'filtered_text'
          : '',
      },

      {
        title: 'Load Time',
        dataIndex: 'load_time',
        width: 280,
        ...this.getColumnSearchProps('load_time'),
        className: this.state.highlightFilterArray.includes('load_time')
          ? 'filtered_text'
          : '',
        
      },
    ]

    //Action button columns
    if (isPermission(PERMISSIONS_BY_NAME['Manage DK Inventory Report'])) {
      this.columns.push({
        title: 'Action',
        dataIndex: 'action',
        fixed: 'right',
        width: 80,
        align: 'center',
        render: (text, record) =>
          this.state.tableData.length >= 1 ? (
            <Fragment>
              <Link className="ico_edit">
                <EditOutlined
                  onClick={() => this.setReportStatus(record, 'edit')}
                />
              </Link>
              {isPermission(PERMISSIONS_BY_NAME['Can delete dk inventory report']) && (
                <Popconfirm
                  title="Sure to delete?"
                  onConfirm={() => this.handleDelete(record.id)}
                >
                  <Link to="" className="ico_delete">
                    <DeleteOutlined />
                  </Link>
                </Popconfirm>
              )}
            </Fragment>
          ) : null,
      })
    } else if (isPermission(PERMISSIONS_BY_NAME['View DK Inventory Report'])) {
      this.columns.push({
        title: 'Action',
        dataIndex: 'action',
        fixed: 'right',
        width: 80,
        align: 'center',
        render: (text, record) =>
          this.state.tableData.length >= 1 ? (
            <Fragment>
              <span className="ico_edit">
                <EyeOutlined
                  onClick={() => this.setReportStatus(record)}
                />
              </span>
            </Fragment>
          ) : null,
      })
    }else if (isPermission(PERMISSIONS_BY_NAME['Edit Report list'])) {
      this.columns.push({
        title: 'Action',
        dataIndex: 'action',
        width: '10%',
        render: (text, record) =>
          this.state.tableData.length >= 1 ? (
            <Fragment>
              <span className="ico_edit">
                <EditOutlined onClick={() => this.setReportStatus(record)} />
              </span>
            </Fragment>
          ) : null,
      })
    }
    //function to select records/rows of table
    const rowSelection = {
      selectedRowKeys: this.state.selectedReport,
      onChange: (selectedReports, selectedRows) => {
        this.setState({ selectedReport: selectedReports })
        
      },
    }
    const { dataSource, currentPage, count, tableData } = this.state
    const components = {
      body: {
        row: EditableRow,
        cell: EditableCell,
      },
    }
    const columns = this.columns.map((col) => {
      if (!col.editable) {
        return col

      }

      return {
        ...col,
        onCell: (record) => ({
          record,
          editable: col.editable,
          dataIndex: col.dataIndex,
          title: col.title,
          handleSave: this.handleSave,
        }),
      }
    })

   

    const renderTable = () => {
      return (
        <div className="CatalogTableEditStyles">
          <div className="CatalogTableEdit_container">
            <div className="Table_top_row">
              <div className="Table_heading">DK Inventory Report</div>
              <div className="Table_action_btns">
                <div className="table_search_block">
                  <Button
                    type="primary"
                    size="large"
                    onClick={() => this.getReport('')}
                  >
                    Reset
                  </Button>
                </div>
                {isPermission(PERMISSIONS_BY_NAME['Manage DK Inventory Report']) && (  
                <Button
                  type="default"
                  size="large"
                  onClick={() => {
                    let selectedReportData = this.state.selectedReport
                    let data = []
                    this.state.tableData.filter((i,key) => {
                      let mpnData = i.id
                      let index = selectedReportData.indexOf(mpnData)
                      if (index != -1) {
                        data.push(this.state.tableData[key])
                      }
                    })

                    if (this.state.selectedReport.length > 0) {
                      let fileContent = []
                      for (let report of data) {
                        let csvObj = {}
                        for (let column of this.columns) {
                          if (column.dataIndex !== 'action') {
                            csvObj[column.dataIndex] = report[column.dataIndex]
                          }
                        }
                        fileContent.push(csvObj)
                      }
                      let headersToShow = this.columns
                        .map(
                          (column) =>
                            column.dataIndex !== 'action' && column.title
                        )
                        .filter((value) => value && value)
                      downloadExcel(
                        'report_import',
                        fileContent,
                        headersToShow
                      )
                    } else message.info('Select report to export')
                  }}
                >
                  Export
                </Button>
                )}
                <a
                  onClick={() => this.exportData()}
                  className="export_link"
                  download
                >
                  Export All
                </a>
                
                {isPermission(PERMISSIONS_BY_NAME['Can add dk inventory report']) && (
                  <Button
                    onClick={() => this.setReportStatus('', 'add')}
                    size="large"
                    type="primary"
                  >
                    Add Report
                  </Button>
                )}
              </div>
            </div>
            <div className="layout_content_box CatalogTableEdit_whitebox">
              <Table //render report table
                className="Table_block_main"
                components={components}
                scroll={{ x: 1500, y: 500 }}
                rowClassName={() => 'editable-row'}
                bordered
                rowSelection={{
                  ...rowSelection,
                }}
                dataSource={tableData || null}
                columns={columns}
                pagination={{
                  onChange: this.onChangePageNumber,
                  current: currentPage,
                  total: count,
                  defaultPageSize: this.state.pageLimit,
                  showSizeChanger: true,
                  onShowSizeChange: this.onChangePageNumber,
                  showTotal: this.showTotal,
                }}
                loading={this.state.loader}
                rowKey="id"
              />
            </div>
          </div>
        </div>
      )
    }

    return (
      <div>
        {this.state.isFormOpen ? (
          this.state.loader ? (
            <div className="loader">
              <Spin size="large" />{' '}
            </div>
          ) : (
            //Add/Edit Form
            <DKInventoryForm
              report={this.state.currentReport}
              currentPage={this.state.currentPage}
              onChangePageNumber={this.onChangePageNumber}
              setReportStatus={this.setReportStatus}
              isAddPart={this.state.isAddPart}
              pageLimit={this.state.pageLimit}
            />
          )
        ) : (
          renderTable()
        )}
      </div>
    )
  }
}

export default EditableTable
